import React, { useState, useEffect } from 'react';
import {
    Table,
    Dropdown,
    Row,
    Col,
    Form,
    Button,
    InputGroup,
    Spinner,
} from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import { toast } from 'react-toastify';
import { ReactComponent as ReactMoreIcon } from '../../../assets/icons/more.svg';
import ProductCostHttpService from '../../../services/http/product-cost-http';
import { StyledPageTitle } from '../BranchesData/styles';
import { StyledTh } from '../PointData/styles';
import ProductCostModal from './ProductCostModal';


export default function ProductCost() {
    const [selectedCost, setSelectedCost] = useState({});
    const [term, setTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [productCosts, setProductCosts] = useState<any[]>([]);
    const [isEdit, setIsEdit] = useState(false);

    const getProductCosts = async () => {
        try {
            const response =
                await ProductCostHttpService.getProductCosts({
                    all: true,
                    withProduct: true
                });

            setProductCosts(response.data.data);
        } catch {
            setProductCosts([]);
        }
    };

    const deleteCost = async (cost: any) => {
        setLoading(true);

        try {
            await ProductCostHttpService.deleteProductCost(cost.id);

            getProductCosts();

            toast.success('Custo removido.');
        } catch (error: any) {
            toast.error(error.message);
        }

        setLoading(false);
    };

    useEffect(() => {
        getProductCosts();
    }, []);

    return (
        <>
            <ProductCostModal
                show={showModal}
                isOpen={setShowModal}
                update={getProductCosts}
                selectedCost={selectedCost}
                isEdit={isEdit}
                onHide={() => {
                    setSelectedCost({});
                    setShowModal(false);
                }}
            />

            <Row>
                <Col>
                    <StyledPageTitle className="mt-2">
                        Custos de Produtos
                    </StyledPageTitle>
                </Col>

                <Col>
                    <Button
                        className="float-right w-25 m-2"
                        onClick={() => {
                            setIsEdit(false);
                            setShowModal(true);
                            setSelectedCost({});
                        }}
                    >
                        Novo custo
                    </Button>
                </Col>
            </Row>

            <Row>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>
                            <i className="fas fa-search" />
                        </InputGroup.Text>
                    </InputGroup.Prepend>

                    <Form.Control
                        type="text"
                        value={term}
                        onChange={(event) =>
                            setTerm(event.target.value)
                        }
                        placeholder="Digite aqui o que procura..."
                    />
                </InputGroup>
            </Row>

            <Row>
                <Table bordered hover size="sm" className="text-center">
                    <thead>
                        <tr>
                            <StyledTh>Código ERP</StyledTh>
                            <StyledTh>Produto</StyledTh>
                            <StyledTh>Custo Unitário</StyledTh>
                            <StyledTh />
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={4}>
                                    <Spinner animation="border" />
                                </td>
                            </tr>
                        ) : (
                            productCosts
                                .filter(
                                    (item: any) =>
                                        item.productErpCode
                                            ?.toLowerCase()
                                            .includes(
                                                term.toLowerCase()
                                            ) ||
                                        item.B1_DESC
                                            ?.toLowerCase()
                                            .includes(
                                                term.toLowerCase()
                                            ) ||
                                        String(
                                            item.unitCost
                                        ).includes(term)
                                )
                                .map(
                                    (
                                        item: any,
                                        index: number
                                    ) => (
                                        <tr key={index}>
                                            <td>
                                                <Highlighter
                                                    autoEscape
                                                    highlightClassName="highlight-term"
                                                    searchWords={[
                                                        term,
                                                    ]}
                                                    textToHighlight={
                                                        item.productErpCode ||
                                                        item.B1_COD ||
                                                        ''
                                                    }
                                                />
                                            </td>

                                            <td>
                                                {item.B1_DESC || "Nome não encontrado" }
                                            </td>

                                            <td>
                                                {Number.isNaN(Number(item.unitCost)) && ("Não cadastrado")}
                                                {!Number.isNaN(Number(item.unitCost)) &&
                                                Number(
                                                    item.unitCost
                                                ).toLocaleString(
                                                    'pt-BR',
                                                    {
                                                        style: 'currency',
                                                        currency:
                                                            'BRL',
                                                    }
                                                )}
                                            </td>

                                            <td>
                                                {!Number.isNaN(Number(item.unitCost)) &&
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            bsPrefix="nexen"
                                                            className="mt-n3 mb-n3"
                                                            as={Button}
                                                            variant="text"
                                                        >
                                                            <ReactMoreIcon
                                                                fill="#bdbdbd"
                                                                width="10"
                                                                height="20"
                                                            />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                                <Dropdown.Item
                                                                    onClick={() => {
                                                                        setSelectedCost(
                                                                            item
                                                                        );
                                                                        setIsEdit(
                                                                            true
                                                                        );
                                                                        setShowModal(
                                                                            true
                                                                        );
                                                                    }}
                                                                >
                                                                    Editar
                                                                </Dropdown.Item>
                                                            

                                                            <Dropdown.Item
                                                                onClick={() =>
                                                                    deleteCost(
                                                                        item
                                                                    )
                                                                }
                                                            >
                                                                Remover
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                }
                                                {
                                                    Number.isNaN(Number(item.unitCost)) &&
                                                    <Button
                                                        style={{height:"31px", margin:"0px"}}
                                                        onClick={() => {
                                                            setSelectedCost(item);
                                                            setIsEdit(false);
                                                            setShowModal(true);
                                                        }}
                                                    >
                                                        <i className="fas fa-plus" />
                                                    </Button>
                                                }
                                            </td>
                                        </tr>
                                    )
                                )
                        )}
                    </tbody>
                </Table>
            </Row>

            {productCosts.length === 0 && (
                <Col md={12} className="text-center">
                    <strong
                        style={{ color: '#adadad' }}
                    >
                        Sem itens para carregar
                    </strong>
                </Col>
            )}
        </>
    );
}